import { useEffect, useState } from "react";
import API from "../services/api";

export default function IncentiveMatrix() {
  const [incentives, setIncentives] = useState({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadIncentives();
  }, []);

  const loadIncentives = async () => {
    try {
      setLoading(true);

      const res = await API.get("/incentives");

      console.log("INCENTIVE RESPONSE:", res.data);

      setIncentives(res.data || {});
    } catch (err) {
      console.error("Load Incentives Error:", err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      style={{
        padding: "20px",
        background: "#f3f4f6",
        minHeight: "100vh"
      }}
    >
      <div
        style={{
          maxWidth: "800px",
          margin: "0 auto",
          background: "#fff",
          border: "1px solid #d1d5db",
          boxShadow: "0 4px 12px rgba(0,0,0,0.12)",
          position: "relative",
          overflow: "hidden"
        }}
      >
        {/* Watermark */}
        <div
          style={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            fontSize: "650px",
            fontWeight: "bold",
            color: "rgba(44,81,120,0.05)",
            zIndex: 0,
            userSelect: "none",
            pointerEvents: "none"
          }}
        >
          C
        </div>

        {/* Title */}
        <div
          style={{
            background: "#5b8dd1",
            color: "#fff",
            textAlign: "center",
            fontSize: "56px",
            fontWeight: "bold",
            padding: "25px",
            position: "relative",
            zIndex: 2
          }}
        >
          Salesman Incentive List
        </div>

        {/* Header */}
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "1fr 1fr",
            borderBottom: "2px solid #000",
            position: "relative",
            zIndex: 2
          }}
        >
          <div
            style={{
              padding: "18px",
              textAlign: "center",
              fontWeight: "bold",
              fontSize: "28px",
              borderRight: "1px solid #000"
            }}
          >
            Model
          </div>

          <div
            style={{
              padding: "18px",
              textAlign: "center",
              fontWeight: "bold",
              fontSize: "28px"
            }}
          >
            Per Unit Incentive
          </div>
        </div>

        {/* Loading */}
        {loading && (
          <div
            style={{
              padding: "50px",
              textAlign: "center",
              fontSize: "22px"
            }}
          >
            Loading...
          </div>
        )}

        {/* Incentive Data */}
        {!loading &&
          Object.keys(incentives).map((productName) => {
            const rows = incentives[productName] || [];

            return (
              <div key={productName}>
                {/* Product Header */}
                <div
                  style={{
                    background: "#5b8dd1",
                    color: "#fff",
                    textAlign: "center",
                    fontSize: "34px",
                    fontWeight: "bold",
                    padding: "18px",
                    borderTop: "1px solid #000",
                    borderBottom: "1px solid #000",
                    position: "relative",
                    zIndex: 2
                  }}
                >
                  {productName}
                </div>

                {/* Models */}
                {rows.map((item) => (
                  <div
                    key={item.id}
                    style={{
                      display: "grid",
                      gridTemplateColumns: "1fr 1fr",
                      borderBottom: "1px solid #000",
                      background: "#fff",
                      position: "relative",
                      zIndex: 2
                    }}
                  >
                    <div
                      style={{
                        padding: "15px",
                        textAlign: "center",
                        borderRight: "1px solid #000",
                        fontSize: "20px"
                      }}
                    >
                      {item.model_name}
                    </div>

                    <div
                      style={{
                        padding: "15px",
                        textAlign: "center",
                        fontSize: "20px",
                        fontWeight: "bold"
                      }}
                    >
                      Rs{" "}
                      {Number(
                        item.incentive_amount || 0
                      ).toLocaleString()}
                    </div>
                  </div>
                ))}
              </div>
            );
          })}

        {/* No Data */}
        {!loading &&
          Object.keys(incentives).length === 0 && (
            <div
              style={{
                padding: "50px",
                textAlign: "center",
                fontSize: "22px"
              }}
            >
              No Incentives Found
            </div>
          )}
      </div>
    </div>
  );
}